import { InfoIcon } from "lucide-react";
import {
  HybridTooltip,
  HybridTooltipContent,
  HybridTooltipTrigger,
} from "./hybrid-tooltip";

export function HelpTooltip({
  children,
  size = "md",
}: {
  children: React.ReactNode;
  size?: "sm" | "md";
}) {
  return (
    <HybridTooltip>
      <HybridTooltipTrigger delay={0} className="ml-1">
        <InfoIcon
          className="text-muted-foreground"
          size={size === "sm" ? 11 : 14}
        />
      </HybridTooltipTrigger>
      <HybridTooltipContent className="max-w-xs text-sm">
        {children}
      </HybridTooltipContent>
    </HybridTooltip>
  );
}
